













































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import _ from 'lodash'

@Component
export default class ModalAddTabelaPrestador extends Vue {
  camposCadastrais: boolean = false
  searchProfissional: any = ''
  profissionalName: string = ''
  loadingProfissionalFilter: boolean = false

  $refs!: {
    form: any,
    imageUpload: any,
  }

  form: any = {
    valid: true,
    profissional: [(v: any) => !!v || 'Campo obrigatório'],
  }

  profissionaisDebounced = _.debounce(param => this.getRecebimentoStore.getProfissionais(param), 500)

  loadSave: boolean = false
  get loadingSave() { return this.loadSave }
  set loadingSave(value: boolean) { this.loadSave = value }

  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get showModal() { return this.getRecebimentoStore.modalAddTabelaProfissional }
  set showModal(value: boolean) { this.getRecebimentoStore.setModalAddTabelaProfissional(value) }

  get profissionais() { return this.getRecebimentoStore.profissionais }

  get selectedProfissional() { return this.getRecebimentoStore.selectedProfissional }
  set selectedProfissional(value: any) { this.getRecebimentoStore.setSelectedProfissional(value) }

  async save() {
    this.loadingSave = true
    if (!(await this.$refs.form.validate())) {
      this.loadingSave = false
      return
    }
    const response = await this.getRecebimentoStore.upsertTabelaProfissional()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Profissional adicionado com sucesso!', icon: 'done', color: '#2E7D32' })
      await this.getRecebimentoStore.getTabelaProfissionaisById()
      this.showModal = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao adicionar o profissional!', icon: 'warning', color: '#C62828' })
    }
    this.loadingSave = false
  }

  changeProfissionalExecutante(value: any) {
    if (value) {
      this.profissionalName = value.nome
      this.selectedProfissional = value.userId
    } else {
      this.profissionalName = ''
    }
  }

  @Watch('searchProfissional')
  async onSearchProfissionalChanged(val: string) {
    if (!val || val.length < 3){
      return
    }

    this.loadingProfissionalFilter = true
    await this.profissionaisDebounced(val)
    this.loadingProfissionalFilter = false
  }

  @Watch('showModal')
  onChangeShowModalEditarHospital(value: boolean) {
    if (!value) {
      this.getRecebimentoStore.setProfissionais([])
      this.getRecebimentoStore.setSelectedProfissional(null)
      this.$refs.form.resetValidation()
      this.$refs.form.reset()
    }
  }
}
